<template>
    <div class="">
        <div class="row">
            <div class="col-12">
                <div class="mb-1 collapseSection" v-for="tempobj_Year of arrobj_Levels" :key="tempobj_Year.id">
                    <header class="" role="tab" v-if="userType!=='Teacher'">
                        <div class="row">
                            <div class="col-12 header-tag">
                                <div class="btn btn-primary">
                                    <div v-b-toggle="replaceStringSpace(tempobj_Year.Str_SortBy)">
                                        <label class="label-checkbox float-right" v-if="isBroadcast && checkAllPermission()">
                                            <input type="checkbox" v-model="isCheckAll" class="test cb_CheckAll"
                                                   @change="handleCheckAll"/>
                                            <span class="span-checkbox"></span>
                                        </label>
                                        <span>{{ tempobj_Year.Str_Display }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>

                    <div v-if="arrobj_Levels[0].ArrObj_Items.length > 0">

                        <b-collapse :id="replaceStringSpace(tempobj_Year.Str_SortBy)" visible role="tabpanel">
                            <div class="">
                                <div class="mb-3" v-for="tempobj_Level of tempobj_Year.ArrObj_Items"
                                     :key="tempobj_Level.id">
                                    <header class="" role="tab">
                                        <div class="row">
                                            <div class="col-12 sub-tag">
                                                <div v-b-toggle="replaceStringSpace(tempobj_Level.Str_SortBy)" class="">
                                                    <K2Row space-between="true" class=" border py-2  px-4">
                                                        <span>{{ tempobj_Level.Str_Display }}</span>
                                                        <span class="when-open text-danger">{{lang("Close")}}</span>
                                                        <K2Text link="true" class="when-closed">{{lang("More")}}
                                                        </K2Text>
                                                    </K2Row>
                                                </div>
                                            </div>
                                        </div>
                                    </header>

                                    <b-collapse :id="replaceStringSpace(tempobj_Level.Str_SortBy)"
                                                :visible="arrobj_Levels[0].ArrObj_Items.length < 2" accordion="level"
                                                role="tabpanel">
                                        <div class="py-2">
                                            <header class="" role="tab">
                                                <div class="">
                                                    <div class=" sub-tag option-tag py-2 px-4">
                                                        <div>
                                                            <k2Row space-between="true">
                                                                <div>
                                                                    <span>LEVEL:{{ tempobj_Level.Str_Display }}</span>
                                                                </div>
                                                                <label class="label-checkbox switch"
                                                                       v-if="showLevelPermission()">
                                                                    <input type="checkbox"
                                                                           :disabled="checkLevelPermission(tempobj_Level)"
                                                                           @change="onLevelClick(tempobj_Level)"
                                                                           v-model="tempobj_Level.checked"
                                                                           class="cb_CheckAll"/>
                                                                    <!--                                  <span class="span-checkbox"></span>-->
                                                                    <span class="slider round"></span>
                                                                </label>
                                                            </k2Row>
                                                        </div>
                                                    </div>
                                                </div>
                                            </header>


                                            <div class="" v-for="tempobj_Class of tempobj_Level.ArrObj_Items"
                                                 :key="tempobj_Class.id">
                                                <header class="" role="tab">
                                                    <div class="">
                                                        <div class=" sub-tag  py-2 px-4 ms-4">
                                                            <!--// changes -->
                                                            <!--<div-->
                                                            <!--v-b-toggle="arr_ClassName.includes(tempobj_Class.Str_Display.toString().trim()) ? (tempobj_Level.Str_SortBy + tempobj_Class.Str_SortBy).replace(/ /g, '_') : '' ">-->
                                                            <div v-b-toggle="tempobj_Level.Str_ID + tempobj_Class.Str_ID">
                                                                <K2Row space-between="true">
                                                                    <div>
                                                                        <span>CLASS:{{ tempobj_Class.Str_Display }} </span>
                                                                        <span class="when-open text-danger">{{lang("Close")}}</span>
                                                                        <K2Text link="true" class="when-closed">
                                                                            {{lang("More")}}
                                                                        </K2Text>
                                                                    </div>
                                                                    <label class="label-checkbox switch"
                                                                           v-if="showClassPermission()">
                                                                        <!--<input type="checkbox" @change="onClassClick(arr_SelectedClasses)"-->
                                                                        <!--v-model="arr_SelectedClasses" :value="tempobj_Class.Str_Display"-->
                                                                        <!--class="cb_CheckAll"/>-->
                                                                        <input type="checkbox" v-if="arr_SelectedClasses&&arr_SelectedClasses.length>0"
                                                                               @change="onClassClick(tempobj_Class,tempobj_Level)"
                                                                               v-model="tempobj_Class.checked"
                                                                               :disabled="checkClassPermission(tempobj_Level, true)"
                                                                               class="cb_CheckAll"/>
                                                                        <input type="checkbox" v-else
                                                                               @change="onClassClick(tempobj_Class,tempobj_Level)"
                                                                               v-model="tempobj_Class.checked"
                                                                               :disabled="checkClassPermission(tempobj_Level, false)"
                                                                               class="cb_CheckAll"/>
                                                                        <!--<span class="span-checkbox"></span>-->
                                                                        <span class="slider round"></span>

                                                                    </label>
                                                                </K2Row>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </header>
                                                <!--<b-collapse-->
                                                <!--:id="(tempobj_Level.Str_SortBy + tempobj_Class.Str_SortBy).replace(/ /g, '_')"-->
                                                <!--accordion="class"-->
                                                <!--role="tabpanel">-->
                                                <b-collapse
                                                        :id="tempobj_Level.Str_ID + tempobj_Class.Str_ID"
                                                        accordion="class"
                                                        role="tabpanel">
                                                    <div>
                                                        <div class="row py-0 student-tag box purple">
                                                            <div class="div_Student "
                                                                 :class="tempobj_Student.checked ?'check':'uncheck'"
                                                                 v-for="tempobj_Student of tempobj_Class.ArrObj_Items"
                                                                 :key="tempobj_Student.id"
                                                                 v-show="arr_ClassInchargeStaff.includes(tempobj_Student.CLS_Class_Incharge_Staff)">
                                                                <!--changes -->
                                                                <label class="col- text-center"
                                                                       :for="tempobj_Student.Student_ID">
                                                                    <img class="student"
                                                                         :src="getSource(tempobj_Student)"/>
                                                                    <input type="checkbox"
                                                                           :disabled="checkStudentPermission(tempobj_Level)"
                                                                           @change="onStudentClick(tempobj_Student.checked,tempobj_Student, tempobj_Class,tempobj_Level )"
                                                                           v-model="tempobj_Student.checked"
                                                                           :id="tempobj_Student.Student_ID"/>
                                                                    <br/>
                                                                    <span>{{ tempobj_Student.First_Name.split(" ")[0] }} {{ tempobj_Student.Last_Name}}</span>
                                                                </label>
                                                            </div>

                                                            <div v-if="tempobj_Class.ArrObj_Items && tempobj_Class.ArrObj_Items.length<1">
                                                                <!--<div v-if="!arr_ClassName.includes(tempobj_Class.Str_Display.toString().trim())">-->
                                                                {{ emptyStudentMsg }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import DataSource from "../../data/datasource";
  import $ from "jquery";
  import K2Row from "../k2Row/k2Row";
  import K2Text from "../k2Text/k2Text";
  import "./k2SelectStudent.scss";
  import Cookies from "js-cookie";
  import { lang } from "../../locale";
  import { getRole } from "@/helper/util_custom";

  export default {
    name: "k2SelectStudent",
    props: ["parent_Post", "portfolio_Type", "isClear", "handleClear", "selectedLevels", "removedStudent",
      "resetRemovedTag", "passSelectedStudent", "passSelectedClasses", "passSelectedLevels", "passSelectedSchool",
        "isMoment","isBroadcast"],
    components: { K2Text, K2Row },
    watch: {
      passSelectedStudent(value) {
        if (value) {
          this.arrobj_SelectedStudents = value;
          this.resetRemoveStudent();
        }
      },
      passSelectedClasses(value) {
        if (value) {
          this.arr_SelectedClasses = value;
          this.resetRemoveStudent();
        }
      },
      passSelectedLevels(value) {
        if (value) {
          this.arr_SelectedLevels = value;
          this.resetRemoveStudent();
        }
      },
      isClear: function(value) {
        if (value) {
          this.clearChecked();
        }
      },
      selectedLevels: function(value) {
        if (value) {
          value.forEach(e => {
            const exists = this.arr_SelectedLevels.find(d => d === e);
            if (!exists) {
              this.arr_SelectedLevels.push(e);
            }
          });
        }
      }
    },
    data() {
      return {
        arrobj_Levels: [],
        arrobj_Classes: [],
        arrobj_SelectedStudents: [],
        arrobj_ClassList: [],
        arr_ClassInchargeStaff: [],
        arr_ClassName: [],
        isCheckAll: false,  //Added by Rajan on 18/11/2021 to check and uncheck whole level
        arr_SelectedLevels: [],//Added by Rajan on 18/11/2021 for storing selected levels
        arr_SelectedClasses: [],//Added by Rajan on 18/11/2021 for storing selected classes
        filterByClassID: "",
        emptyStudentMsg: "No Student Found",
        checkType: null,
        userType: null,
        is3Level: ""
      };
    },
    created() {
      this.userType = Cookies.get("userTypeSession");
    },
    mounted() {
      const self = this;

      this.$nextTick(function() {
        self.init();
        this.initTags();
        $(document).on("change", ".cb_CheckAll", function() {
          let check = $(this).prop("checked");
          let checkboxes = $(this).closest("header").parent().find("input[type='checkbox']");

          checkboxes.each(function() {
            // if ($(this).prop("checked") != check)
            $(this).prop("checked", check);
            // $(this).closest("label").click();
            // $(this).closest("label").trigger("click");

            // self.isCheck($(this).attr("id"));
            $(this)[0].dispatchEvent(new Event("change"));
          });

        });

        $(document).on("change", "input[type='checkbox']", function() {
          /*self.verifyCheckall(this);*/
          // self.isCheck($(this).attr("id"));
          // self.verifyCheckall(this);
          // self.$emit("tags", self.arrobj_SelectedStudents);
        });
        //Added by Rajan on 09/11/21 to get current status of selected student checkbox
        this.$emit("isCheckAll", this.isCheckAll);
      }); //nexttick
    },
    methods: {
      lang,
      /*#region Loader Functions*/
      showLoading() {
        this.$vs.loading();
      },
      hideLoading() {
        this.$vs.loading.close();
      },
      /*#endregion*/

      isNull(obj) {
        return (obj === null || obj === undefined || obj === "undefined" || obj.length === 0 || obj === "");
      },

      async init() {
        await this.bindClasses(); // changes
        await this.sortByLevelClass();
        // if (!this.isNull(this.parent_Post))
        //     this.initTags();
      },

      initTags() {
        if (this.passSelectedSchool) {
          // this.isCheckAll = true;
          this.arrobj_Levels[0].ArrObj_Items.forEach(x => {
            x.checked = true;
            this.onLevelClick(x);
          });
          this.handleCheckAll();
        }
        if (this.passSelectedStudent) {
          this.arrobj_Classes.forEach(m => {
            this.passSelectedStudent.forEach(d => {
              if (d.CLS_ClassName.trim() === m.Str_Display.trim()) {
                m.ArrObj_Items.forEach(a => {
                  d.itemList.forEach(x => {
                    if (a.Student_ID === x.Student_ID) {
                      a.checked = true;
                    }
                  });
                });
              }
            });
          });
          this.passSelectedStudent.forEach(d => {
            this.onStudentClick(true, d.itemList);
          });
          this.$forceUpdate();
        }
        if (this.passSelectedClasses) {
          this.passSelectedClasses.forEach(d => {
            this.arrobj_Classes.forEach(x => {
              if (d.Str_ID === x.Str_ID) {
                x.checked = true;
                this.onClassClick(x);
              }
            });
          });
        }
        if (this.passSelectedLevels) {
          this.passSelectedLevels.forEach(d => {
            this.arrobj_Levels[0]?.ArrObj_Items.forEach(x => {
              if (d.Str_ID === x.Str_ID) {
                x.checked = true;
                this.onLevelClick(x);
              }
            });
          });
        }
        // this.arrobj_SelectedStudents = this.parent_Post.arrobj_SelectedStudents.map(x => x.PostTagUserID);
        // this.$emit("tags", this.arrobj_SelectedStudents);
      },
      resetRemoveStudent() {
        if (this.arrobj_SelectedStudents?.length < 1) {
          this.checkType = null;
          this.is3Level = "";
        }
        this.arrobj_Levels[0].ArrObj_Items.forEach(d => {
          //level
          if (d.checked === true) {
            let isSelected = this.arr_SelectedLevels.find(d => d.Str_ID === d.Str_ID);
            if (!isSelected) {
              d.checked = false;
            }
          }
          d.ArrObj_Items.forEach(a => {
            //class
            if (a.checked === true) {
              let isSelected = this.arr_SelectedClasses.find(d => d.levelID === a.levelID);
              if (!isSelected) {
                a.checked = false;
              }
            }
            a.ArrObj_Items.forEach(x => {
              //student

              if (x.checked === true) {
                let isSelected = this.arrobj_SelectedStudents.find(d => d.Student_ID === x.Student_ID);
                if (!isSelected) {
                  x.checked = false;
                }
              }
            });
          });
        });
      },
      // handleRemoveStudent(value) {
      //   switch (value.type) {
      //     case "student":
      //       this.onStudentClick(false, value);
      //       break;
      //     case "class":
      //       let level = {
      //         Str_ID: value.levelID
      //       };
      //       this.onClassClick(value, level);
      //       value.ArrObj_Items.forEach(d => {
      //         d.checked = false;
      //         this.onStudentClick(false, d);
      //       });
      //       break;
      //     case "level":
      //       this.onLevelClick(value);
      //       value.ArrObj_Items.forEach(d => {
      //         d.checked = false;
      //         this.onClassClick(d, value);
      //       });
      //       break;
      //   }
      //   this.checkType = null;
      //   this.$emit("resetRemovedTag");
      // },
      async sortByLevelClass() {
        try {
          // if (this.portfolio_Type !== null) {
          //
          //   if (this.filterByClassID !== '') {
          //
          //     DataSource.shared.getAllActiveStudentsByClass(this.filterByClassID).then((result) => {
          //       return result.Table;
          //     }).then((result) => {
          //
          //       if (this.isNull(result))
          //         return;
          //
          //       this.groupStudentList(result);
          //     }).finally(() => {
          //       this.hideLoading();
          //     });
          //   }
          // } else {
          this.showLoading();

          DataSource.shared.getAllActiveStudentsBySchoolWithMode("ProfileImagePhysicalPath").then((result) => {
            // DataSource.shared.getAllActiveStudentsBySchool().then((result) => {
            if (result.code === "88") {
              window.location.replace("/");
              console.log("88");
              return;
            }

            return result.Table;
          }).then((result) => {
            if (this.isNull(result))
              return;

            // this.groupStudentList(result);
            this.groupStudentList2(result);
          }).then((result) => {
            this.initTags();
          }).finally(() => {
            this.hideLoading();
          });
          // }
        } catch (e) {
          console.log("sortByLevelClass err", e);
        }

      },
      groupStudentList(result) {
        let sortedList = this.groupBy(result, "SMT_Code", "SMT_Code");
        let classList = [];
        let levelList = [];
        for (let i = 0; i < sortedList.length; i++) {
          let tempLevel = this.groupBy(sortedList[i].ArrObj_Items, "CRS_Course_Name", "CRS_Course_Name", "PK_Course_ID");
          for (let j = 0; j < tempLevel.length; j++) {
            // let tempClass = this.groupBy(tempLevel[j].ArrObj_Items, "PK_Class_ID", "CLS_ClassName");
            let tempClass = this.groupBy(tempLevel[j].ArrObj_Items, "CLS_ClassName", "CLS_ClassName", "PK_Class_ID");

            tempLevel[j].ArrObj_Items = tempClass;
          }

          sortedList[i].ArrObj_Items = tempLevel;
        }
        sortedList.forEach(d => {
          d.ArrObj_Items.forEach(m => {
            levelList.push(m);
            m.ArrObj_Items.forEach(e => {
              classList.push(e);
            });
          });
        });
        this.arrobj_Classes = classList;
        this.arrobj_Levels = sortedList;
      },
      groupStudentList2(result) {
        const array = [];
        let classList = [];

        result.forEach(d => {
          const academicYearExist = array.find(v => v.Str_ID.trim() === d.SMT_Code.trim());
          if (academicYearExist) {
            const levelExist = academicYearExist.ArrObj_Items.find(v => v.Str_ID === d.PK_Course_ID);
            if (levelExist) {
              const classExist = levelExist.ArrObj_Items.find(v => v.Str_ID === d.PK_Class_ID);
              if (classExist) {
                classExist.ArrObj_Items.push(d);
              } else {
                const newClass = {
                  Str_ID: d.PK_Class_ID,
                  Str_Display: d.ClassFullName,
                  Str_SortBy: d.ClassFullName,
                  ArrObj_Items: [d]
                };
                levelExist.ArrObj_Items.push(newClass);
              }
            } else {
              const newLevel = {
                Str_ID: d.PK_Course_ID,
                Str_Display: d.CRS_Course_Name,
                Str_SortBy: d.CRS_Course_Name,
                ArrObj_Items: []
              };

              const classExist = newLevel.ArrObj_Items.find(v => v.Str_ID === d.PK_Class_ID);
              if (classExist) {
                classExist.ArrObj_Items.push(d);
              } else {
                const newClass = {
                  Str_ID: d.PK_Class_ID,
                  Str_Display: d.ClassFullName,
                  Str_SortBy: d.ClassFullName,
                  ArrObj_Items: [d]
                };
                newLevel.ArrObj_Items.push(newClass);
              }
              academicYearExist.ArrObj_Items.push(newLevel);
            }
          } else {
            const newAcademicYear = {
              Str_ID: d.SMT_Code,
              Str_Display: d.SMT_Code,
              Str_SortBy: d.SMT_Code,
              ArrObj_Items: []
            };
            const levelExist = newAcademicYear.ArrObj_Items.find(v => v.Str_ID === d.PK_Course_ID);
            if (levelExist) {
              const classExist = levelExist.ArrObj_Items.find(v => v.Str_ID === d.PK_Class_ID);
              if (classExist) {
                classExist.ArrObj_Items.push(d);
              } else {
                const newClass = {
                  Str_ID: d.PK_Class_ID,
                  Str_Display: d.ClassFullName,
                  Str_SortBy: d.ClassFullName,
                  ArrObj_Items: [d]
                };
                levelExist.ArrObj_Items.push(newClass);
              }
            } else {
              const newLevel = {
                Str_ID: d.PK_Course_ID,
                Str_Display: d.CRS_Course_Name,
                Str_SortBy: d.CRS_Course_Name,
                ArrObj_Items: []
              };
              const classExist = newLevel.ArrObj_Items.find(v => v.Str_ID === d.PK_Class_ID);
              if (classExist) {
                classExist.ArrObj_Items.push(d);
              } else {
                const newClass = {
                  Str_ID: d.PK_Class_ID,
                  Str_Display: d.ClassFullName,
                  Str_SortBy: d.ClassFullName,
                  ArrObj_Items: [d]
                };
                newLevel.ArrObj_Items.push(newClass);
              }
              newAcademicYear.ArrObj_Items.push(newLevel);
            }
            array.push(newAcademicYear);
          }

        });
        array.forEach(d => {
          d.ArrObj_Items.forEach(m => {
            m.ArrObj_Items.forEach(e => {
              classList.push(e);
            });
          });
        });
        this.arrobj_Classes = classList;
        this.arrobj_Levels = array;
      },
      filterByClassIDChange(value) {
        this.filterByClassID = value;
        this.sortByLevelClass();
      },
      sortByClass() {

        this.getStudents().then((result) => {
          let sortedList = this.groupBy(result, "SMT_Code", "SMT_Code");

          for (let i = 0; i < sortedList.length; i++) {
            let tempLevel = this.groupBy(sortedList[i].ArrObj_Items, "PK_Class_ID", "CLS_ClassName,CLS_Batch");

            sortedList[i].ArrObj_Items = tempLevel;
          }

          this.arrobj_Classes = sortedList;
        }).finally(() => {
          this.hideLoading();
        });
      },

      getSource(obj) {
        let imgsrc = "";
        if (obj.Profile_Img == null || obj.Profile_Img == "")
          imgsrc = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAADwCAQAAACUXCEZAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfhCAoFIgoPraT3AAAhSUlEQVR42u2deZgU5bX/P2/17DPAMAuoKJuKkc0FFRAQUNzAJUboAdxC3GKues2Niff3y01wicnj9Zq7RBMN3mhQIzSIhiCLiuyboKAsCrIMqyyzwCzM0st7/6iqXqt7eqleZqhvP/NMdXV11dv1rXPec877nvOCBQsWLFiwYMGCBQsWYoPoeD/p7c55vT29RS9PqSgVpbKMcjojKAZyKAQaaQVOIqnjhKiS1bJaqZb72ZdbeXu9RXAGQoo5vcVgBsnB9KUPJQmcqppKsYetbJVfTaoU0iI4rXD0EFfLEVzBIDon4fR1bGOjWONaM+WIRXBK8V5f941yhBhJrxRdsFKuYbVYYt9nEZxUvJFXMFrczE1cFOkoGwUUUkguOd4/QRZgwwa48ABOoJUW7a+Z0zTSiCdyA74Ri1jcsHJas0WwyZhZmHcLdm6iwPjzHLrQhS50ppD8BK7TRCN1nOIUp2gNd9BpFgpH3oe3nrYINqOfzWcCdiYYUWujK6WU0TUhUsPzeJIqqqkxlutGFghHw8JMl+aMJnjWJcoD3E1x8H6FMs6ijK4oKWiFhxqqOEaVEdG18m0xw77VIjhWuS0Sk+WDXBW8v4CzOJtuZKWhTS6OcZSjGGjmDcxgtr3BIjg6cs+SPxaPBXuzBfTgXMoyoH11HOQAIWzWizdc/zHloEVwZHIvFT+TFWT778ujJ+dSmmE3rpqDHKAlcGernGV7aeJXFsHGPe4w5RluCGxcd/pwTkp62vh65yPs5TgBAS/JEqbbP7MIDpTcITzDhEC57UufcF5RRqGRfewNluV/KNMnbrYIViV3oPIct/u3pDMX0gtbOwrBuNnPLuoDJXkev7bvOMMJ/ltZ9nPyQX8uy7mIs2mPkHzHLk4EGN7iNdv0H1SfoQS/lt11Gs/7G8alDKQb7RtVbOd4oKf8gvhPe+sZR/DsceJl/5hyCQPpTsfAUbZT479jh3y0YtkZRLCjhJe4z3ftTgzmHDoWDvOVv68s+Uv2k3ecPCMInn2r+BM99HdZ9OPijHWEEnOi9rAdp2/HMfGLSTM7OMF/6571Z27zXbwPA8ml46KZbVT6+8nv87D9RIcleM4N8k2fidyFIRkXn0oGqtlEne/tcXH/pAUdkOA38opekI/p11Pox4AOqZiNlfUutvvGoiQz8n+aqtHkFBE8d7DnXfrr78q4gk6cWahjE34O8TbPlMnbOgzBs6eIGRTqF7yY/h1xtm4UgZCd/nLcxE/sb3YAgpdlVf1GPqW/K+SqjBjySxdq2ODvPP259tGHne2aYMdZOBilv+vDpWkZqs8kuNhMpe/tClfF1GPtlmDHIBbQU922cRl9sACwn89x62+OMMG+pV0S7LieOXRRtwsYnlDCQUfDSdbSqL9pkBUVC9sdwbN/JF7VZ2aUM7xDhzPiQSvr8epml3ys4tXkXCcpg65S9P+teFE/94UMPeN7XqMb35NWfUhCEbfYbXOWtROCpZj7XzypK4jLzlCnKBrleTY5PikebT9rwKLl0vyrmN3z2uQMMU3dzmJohxslMhuH2eA1uMTbZdPGujKa4Neyu77DJHU7l1F0tRiMwjde7ZvRNbv2HnM9Y2EyvXP1saJ8Rp9x4ch4UccKvBkwH9TazaTYRIIdNvm2mKy7RaMpspiLGo2s8LlN75VPNk9Rm2ZkSbH9NXGvut2JMXro2UJUyKEH3+n5jP2beg2Yb5a5ZTOL3jmviId99OZbnMWIbM7jiE7xpWUlcxdlFMEDfsdP1a1CRlv0xoUsenBYm+IjhprlF5vSBzvu53XdtBprKecE0MBymnSt+IgZ0S0TCJ59o1ighqpyGZOUaihnEupZrlvUTibYP047wXMHeNaoQwo2xlgDCiagluVoRnSdMirRXMUEp0U5zvIsVukVDLPoNQVduUqXu86e+fO6pZHg17KZzbnq9iVWUNI09GCwvtnLNWtZVtoILn6Ja9StC7nQ4sVE9OMCfXNs1e/S1Ac7pvKOutWdUdaIkcmQrOaovl1R4Ug5wXMHe9ap+dmFjCPHYsR0tPCJXvClgaHxZhrHqaLfyPO8rdJrY7hFb1KQywg9DlWEw5GfUoILXmKQunW5NSSYNBQzRN8cIJ5PoYqec4ucr36zD1dYPCQVn7Ff64jlzRVLUkKwo5yvOEvVHNdbs62SDBcf61Plj7sGxz6HOh4V/bpKr2JNpksBsnxhj25Zr6SgD3ZU6HM2+luRq5Sg1Je1d6fjjiSraEcJO9RSGmWMsXzflPnEy/TMxCP0t59KpgS/pNKrMMSiN2UQXKkTdY58IYkqevY47lO3LraGBVOKTnxPJ/uh2dckieBlWeK/VLHt4r2chVTBK1JC/CmW4YcYCK56lAGqwrjijCm+kDnw6xT7Vz2UBCPLUcK3qtl8Ppdb9zst2KhnFtdk9Yu2QGLUoiieV+nN9hntFlKMQXq6Zon71yZL8KyByhY18n0J/aw7nTZ8g7Y8hFMZPPEbEyVYeU6lt8g3EG0hDein54tke541UUU7hnC7unWJZV6l2dQapG/eOesS8yT4WVWVd7XmXaUd5+oBYkV5xiSCZ13JzXonbyH98Bq5tzuuMoVg5Teq/JZ1mHrO7Rtn+yp8TjeB4LmDuV7dGmjd2wzBAH1jfNv9cJsEy5+r8ltOuXVnMwTdvdUClScS9IMdPdirzqkb2U6XyuiYOMxazR+29b3zUAISLJ5Q6e2kTuKwkCHooQ89ZLv/KQEJdhRxSM08GkJf665mFPbwhbpR23zevY1xSrCcotKbm7K11C1Ei97kqRtdcyviVtHiAfV/33a1CtmZAZu3tKvOUswEzx2srt8rrCqxGYk+ev86PJKzFIFg+ZBulFtFGTIRhV7HVZkWB8GOfHmX/qRYyEx4Dd973siLmWBxC8UAedYAQwY7S1qR5pKCm2ImWGoVJ3taA4QZC4Xz9C17jAT/o4Dx6tZ51n3MYOjsyNtmFsZEcPNtqmVVYKWnZDTK9DXSC3Nviolgabfkt33gXN1mqoiB4DfyuNEiuH0paW5emBs1wQWjVckvsLL3Mx4lemXQovpRURMstCk61gBhe4B3nO+m6Pvgm4O+aqEdECyiJdjRR53brtDNunvtAN11Ege81ys6Cb5JN8GtAg3tAdneSXiuG6IjeKSloNubDGtKelRMBJdZd66dwDsdckQUBDt6qOuFKpaL1G7QVaex73shjk9WOPktMXGQoUqbEVIQskSl+klhmGKIbk6iLj5SRF6U16rDDeT4jWE3oC9DJEMCr7V+N8JolSf9u9E87PXa8lYKXQ2mujX5VkYKdUvVgbu4YaOrVqTFdTXvtUGwHCFMV9ATtbzWJ5hg+Mm7BlfbxWq+4gR1SIopZxBXc0EUZt9t2hl9BDczRdvyMI27/Y5tZCFvattOlhucbT0vAG6eJlJhjAZ2s56dHOcUkiLKuJChXBnQ2kZvK0JhfO1YUKoRrIxok2AxRP+K+ZjDiKie1TpmsBTf8l/HOMY23mMcUxNKn1FYGkTwmojHn2S9JiGLwxIs2cMsVuHx7qmhhl18SA/u5doUKekydqmtubKNPlgKPUMlGT3wYT6M4qgj/ILFGr0unDi17VYW8hx74rx2KznAXg4GtOfbqAiGjXo5wSB42MxvWIEHkFpbnVq3cphnDY53Grw8JvTCGgZJEVGC5/VRZ1TnJGntow+4to0AaLOXxO7czDB6IDjOGhZyGIWd/DdPxzWE6eZK1pDNfPSZ4qfYBEgGsj0Meeu8i0ZK5jPV4Jh9vMxhwEU/xjGUUnJpYCdfs97w4XEnrIyNUUC2KgZd5vXUq5caSrBLWyygSxIakQucZF4bR/0vuwHJrczkLs4nj1zOYzJ/ZRJu4GtmEc+qb1lcCQi/G9zMSsCpD5yFoJp1gJvugOBTw67kAw4Cgl/wGpPoSSFZFDOUH/Iq/+FLEksBugQxGIZgoX1cnIQmTEACSyIq2RrUxezH83hQ0wQ/5nYk8DEH4rr+ZRQBJ9imyeS3HAWKuCxsh/I1IHiSLGA3e0OOOMpSwMkTevA+6HqvpIHg4CTuYF9I64GTUcfuB5QDTcz2LogciiW0AqUYF4J6lGKggXVx3oLhQDYLNPncBHgYHcYyb2I1AFdwEZcB2fw9xLxahxO4UJ/dlFYUR0lw3+QRbONuPMAqvVKMAVTpui7M0rQ2TZ1ui0tJFzIUgDW4gFZWAS5D2VN76NWAk++TjxoBXBFkDNWyB3BnBL0+xsT5kQnWJkEnZ+3fCfQBXMzWV9kMwV6jh9APV+ABDoaxadvC9+gG1LMBN1upA8rCprV/STVQzFDgMkqAOlYGGWH7AXeAij9NbcDrVIjU14a8TppkZmnoHcGK/nunlhJVUvKS9Jzdzy+xsYkNjAoTDYJIwxzn40ahgZa4VhcvZhjzyeZDLuQzwM24MOmVJ1kHSMaiAN0YyiJsLGZMkJEFIiBIczoonBEcwsjBnoQwB0A+iqphyh1F9oYwEtzUN+hpMB3DtTW9ZukLxgThtNbYyM9pY9x2/HAANlHLBsAdVkHX8hng5A7tJo3Rvlcf1E9Hbm0qIbysKb3Cqmhbb723Sh4ewg3sYmkEApvCfrteOyreOHkv+gIu/kgL0CtYn3m91bWa+dTTqznUld3+HiQ1wa31BTJcYXzrZIQ5AlmTfcKqaHlesiUY+jOSdcAcRhk4Y51oAY6GufHwLVlAYdwtLOEq9mJjR0QDq4a1gJtr/AYjhvEtIiDUKelMA3DCz2Lp5lW3VYax52QFOgLEsmf4SJY2sJiXVGXyMOuRfMc/uCfks75UAVsZFtb0EUCvuFto42pmaza4ZFyYow6wC7DxFm+FRK52e4s5FnEeR8hiQ4ak5+kjdbIsrIoWpYGHJgc9UGeWzOe7kM8GIYHlHA8TxvwIIKEIUbnXbh4Qpm7Q6QhDENl84KegLwIEn0BGESxKwxKsc5/speoeIAc4GTyyBdxCFnCcWQb9sORlTgL5CY3RlHKlZrtOiOgBh/aWaq+6yi9MM5xcYF+b4dfUIKdtCSYlEgzFWm3TJSFRpCJuQQL/4K/UBMnVK6gLf92Y0JChYCjgxBZ2AHAztUBnPmV5wGsWpUA9K/C5nKMBhRnMCTGVnGmT4MCR3sA7nCIJhvtYTD3NBl7oj/mSSuA9NnItgyhFUM12lnBIs2d/lOC1+/JxhE9rWA94uC7EUi9nOAuwscirQbK4j284gIs/8wnX0o9S8mmimp1s1LROaKDD6KErNlGCA2dPZAUZsVpPk/ynrYIZhkGGLF7gSQ4gOOCdbeHv5kxPst9Zw0bAxfdDPlEYzQLgC056CenGU/yWw8Beg8EIeCqEBKNEXnNCHV6CO4dX0bm6rZl8TAobryrhVcMsDMH1/HeS02lcrMMFXOTN2guU/e8Bgvl++/rxkhbvCiZtEDNSGqdWQnR1qATnGrFuxm0LPavCfTyP8fVyeJJ7WMCXHKEO6MzZXMINgQ5eGHhwQsB4lQsnRAgn+H9ezVKcyDAGWGeGshX4mHsDDJf/z10sZRuHqKeVLpQziBuDFr2XEXplTxIJDtCSjpPqsOL3U6CkLZiNVj3OVmsvCaeic5IjwRZSAZuhBFsEdxgoURBsoePSrqlxEzt9C6mFl7UWi+AOCbdF8Bkiwa3hCW6xCO7YKrolSNgtdDCC69R/TututUN4NfOp8ARXGTwCFtoJWoJYNCBYVhv00hbamQTL6rAEC0uCO4AEiwAJDpxVWS2SIsFu7Yz5YfbnhZl+rk6TESFT7NTxHyXMzBP1rP6femgxPE8opFZoITdMiK85aAg/8nE5YQdeWyJ4KjlxDtcaS3CWkQQ3m0zwMn4HSH7JdQH7G/hnDiJ5GONSqQ7+ApwTMrfxU62wwm/0giIBqGYK4PRLNKlmctCecPiU3wLwFDcYfn5DwDibQj7ncAk3h0zzVY+bFXY5wOsjjNe9G2cBOl2ClQgqWkt/P20qvZLlKCjYQia7d2GM4X4VjaxFQQmZ3Nqk7c/WUk2DoWgvv98Vsic8weqRy8N8rgS8oIk9zONxLWMx+Ljwq44pEV/xQc/3kOETwMW+wEPNwUE2a1ubQhKtRpIFfEulwfd2swvwcFvQ/mNs0rY2xpmEFg4n+Fzb2syRiB6n+pLeR+5l7zdj81yNX4kRrFSGVdHZ+1o0CZZtrVoZA1b5egcWBBRBgZ5cwudk8QFPGCh2gMtDqoWs8SojDwuYbCLBH3lDPC4+DWqpP2ZqRSSaOMR63sODm3kMifl6bxlWQsmJU0/qetcTXoJvr1fnqrpN7IVbWAXoSRPLQ36MOnl1Zcj8wyo2AJ6QvvAkawFJd0AxedL5cr+WroggSbnkk08+JQzmIS1FZVdQYlo0yNHOE/iKz8Rq0tt73N4QPtABpivpr9kDSP6FLGAv3wR9PoRi4JT2GPiwmSqgKGSSeyW7AOktrLDPtJZuYx+g8AQCqOTLKL93I26gMc3OZaPvBhGBYKEV0Kgz0YJWabycwYAtxDDqxlBAYXGQI6RavKOCnmePNu38CvpxOZDN+6a19GMEcClXcalfy6NF56Sm7LWNuiAGw0mwVl3hlEmXrdUSqa/z5tiuDFJ9grEAfBag4g6xGXCFGFgntMo34ynQXKSVJo19tWo6ZKz2B2ui9CY+wgb0TDPBOmPyq4gE6x+bRfBn1AJFjAOGaiVUgp2iflphkPkhhlRvtTK5H7ZQDXRmFHCpVlhhtUmapt575mspIrRkg79d0UQTTdSwlRm8CygGE+WjeaiaQl7uBAkOLoCSZSzBJ025aR7NbLkGBShhGIsRLOX6gKM6MZK9CD7lLm8AZA0gQ/rf0xqZ12iFFYaxEBsLI9aRjK0rGUEhkMtIFgPLjZdB8M6KFpqvUcQDWu2A2HCPiWEOnWB3ZAmeVKkqc6cpwY4DfIl/HRpV9X0elFYGI8kG9mr1FmG3ViXu9hAP+HN8hRVsjNa86/qEW3pc89XHau/HIYEtWj5UuDCFXrb1XkbF5VaaF+Zo1Id4T04+FNnIklolI8Mkqdg9YCd6wgdAf00ZB8d9zuVSIMurpJdrhlRwMafVOIELvAnX2uISAco9PizBA/RGX4j3EnoDbsP6dgSFJKr4I4+xxbRARzzwatytQkZW0bCRqwGq6ZHgTWvW+rCRfrm+I9gLLAtI/YBsRrMRWMVPsWmGVKgHXMta1NJl+vnyGMouBJ94lXtiCnqkn6szkv3Acu42kCk90OGmmkOs5hOOMJ0XvA9yIoGO+MIc+gCS/Cz4k9BywmvkP/t/JX5s11yywEIICrCfHfQPOPZySqihgWWMYzM1QKegkkWwl92A4E2/rEO1F9zHHs5PoKVbOIAAZjIzqKUH2cLlhoEOtN63FyPozjuc5l2eiSPQYQ6qvOyFdgNBcK3R5cVtilRg0MOEesNlDAMUlnjHfK4JappL84BFwNmEpgES84Y/0c5j1Bd+GsX378AJbDfBFogPbp+KXtcmwVOOqILnSbAXrtZqLRv3MauCygzp3vAXbOeLMB7wekCGPV/8j2OzZpsbn3ltFAMaHs3QSVcsq0bvuXfbj7apokGuEb1VsU+krP8GTgFFvB30DNXzKLU08kmQC3IBF/ItCi/iBM731rLxhS5rgU4h56vmSaqpZ6XXAo4Vn9IIdGFG0IQAF/dRTz0r28zyfZ9soHPaSqKFV9CGuUnKKt0pSdwDHk1hUCi9G1cDIiTcUaStCXMctYRgsBugtn1MyPnOZrih0jd4cA3CCs1+BlbXoDN30vzrZWEDHQ0cZC3/zrsADAgpINdWIMPo83hCHUd9bgZRSLBriU17Lpxx5wnvYyvgNkykHsOHqIMJgRpiBO9qSk6EKOjv+MLPA/aHzVtY4VQbZcyzuSVkn5NZ2qCCkfyPYwGCreynl2Ggw18+8g0GLo0CGf6zPO4xbGesoQ6nN64gP4pKgqdUslOVwuMJeMAuTe2G4mIuAISBN6zbq1eGlBpdjQvoZ5jj39ugsIIRhGFY4SMk0JfBBt8YSF/AHSLDoUGJcn4VElY1DmSINgMdsYY6juk98Db7gagIBrkoSPRjxGmW4cETplfMZRQePCFKOkvb7wopsl/FSjy4wsyTKmYoHiQfBYUP/JWzJ+zrYzx4GBMmEjVWa6nbMDQhyaKUIfyYV7kyihCGbxaIJ+IrTgW9yPixNsCcG+QSgIKwxcLa6oFbtECE8W1TZ0WGmy0Z/X6fknLhm0cZblZlZI/UFtUvCZ5VmR2mXnxz2JLl6pXMnFW5QAv8iHGTlkbVB0PDysLTFMBpauJa4URpw57MCnNbYt3vu83ZAb1yfoztif6XRFsjs63jzCs1V63H9RrkKuNfYIBpzbq4H8RCZsPL0If21qgJBulQ/x+y7mBGQ/oYmh1OBxmiYIEawDlNtXUXMxhVuoKuD5rz1BbBt57WV6GzlHQmQ5dfOd/eFBPBIDQlfcDK989YeHziNzu8mRgGDQvV0YaWiHP8LaQTh3X3r6rTRzETPK1Zvq1u7bXuZIbCy8zM8S0xEwxihvr/mMkZQBbMQSMndBL/EsmTDwv7Vn353Errbmak/GrRsjUTt8dFMPC6fiqr7k6mwe1L2nk90nERCW6epc4FaQlcc9hCBqBSN7BqmufETfC9jeI1dWtXXOt9WkgWpHcOOX+6tzFugsH1P2pyb73BGkcW0ukgaYZvi62NVajbIHjKETlLl2ELmQOdDfHOnd8lRDDIF1XtfCKB+R0WzMVRfYRAypfaOrZNgidv09ajYrt1ZzMEXiYW2HckTDAov1JluCruKTwWzMQRfZKd9DwXBXttHzJxkz6ytM26u5kkv+9P3mgKwaD8WpXhWg5b9zfNOKinqXh4Oiruojlo4mY9+edLa/AwrXB7E/ilw77VNIKBX6nJRI1aaraFdLlHWlTDKadH940oCbbv0GNaO0yvZGkhWjT5ilD9YfIuUwmG1l+pzpfLMrXShq16TuaJ7Oei/U7UBN9VK7T85koTksMtxI4TviGff7vjpOkEQ9mfVOGVbLKGD1MOD1/om1/yv9F/LwaCx7rk46q7VB9SkNBCsrFDr2Xn4VG7OykEQ8UytMkh35hY7NBC2zilJnwC8lV7TJXfYsxVdP5cHTf0sMkaIU4ZJJv0+MNh5/+L7bsxEnxXLY+rW9V8bd35lKlnb4r3o3fXJZVgsM/Vo1o7rLSWlKDKJ0pzKj6I9dvxVM57WFXTkg3WGmlJh5PP9M7wiOsnsX8/DoLtJ8T96jUb4yrgZyEWfKEHJz3yvqlVKSEYJi2SL6tblSZWXLcQij3oZTfE7yviWr8gzjVcOv0crWzt5pDasRbMQo1PQ25r+FV854iT4PEtylRVd7hZZy2FlxQ0s1Z3juqVSdOaU0owTNzO/erWaTZYPnESfN/1enK3FD+cGHfoUIm/CfbZ/F7dOuaLk1owCVu8qWW8MGle/OdREmlE+VP6Qkh7rXnTpuIbduubn/JviZwpIYLHulyTdTPvK2u+lmk45Btzr2Sy3Z02gmHqMc8EdT0IyQbLnjYF1b7QRq1nvP1EYmdTEm3O5G3i+2r+kpvV1hhTwjjFan203SkmTU444K8k3qRJy+Uj6lYLy9NW9bxjoIGV+lKeUj44aWniZ7SZ0ay5m+3aGjdujnBu3EWIz3ScZrl3wRE5veJ/zDinzZymzVk2sVQMBXDyHee1UVvSghGaWOFdYlL8p/2X5pzVtGWCpZjzKg+p24WMDql+bqEt6V3hK3bz5qQfCZNiR4pZDRRyxyNCrW1PI8utyjwxoZ5lvjs2lweEaaFBYWYzX8vu6tBXacxjdMjKZRbCWc4rfekE75fbx7rMO7fNzIYu8Iybl3ehGAjg4hDlaVuHpH35vSt9wzV/K7/LTHpNVNEqHnaKu/VZuy0st0qZtolDrNAdI8SMHfeYS6/JKlo3txy/F0/o7/ozwGIxLL7lS+9InHhl4mPC9GE5xfxGC1nxU+HNndnBZmsw0VgQ+Jwt+r2R8teTHhVJuFEiWc13/JA/6xGPcoZFvdrBmYIW1vvK2rTygP2t5FxHJO8nzLlOzqVY3c5nOKUWq17Usta3BHetvLNiWbKuJJL5M2YNVBboi4YpXKYtD21hD1t8lRIqPeMnJzGHQCT3p8zr5prtWwi4F5ed8XFqJ1/gt0DZUtfkqUnNxhXJ/kEOm3he/kK/TgFDE1rTtL2jhg2+iJUUfyj7mdluUcoJBphzu/yrvnKk4CIGJMN4bwdW8062+1RzPT+yz03+VUVqfpyjP7MYpL8rZUgbK4V2PJxik/+Mly3KlIkpSbK2pebnzTkx/o3cbK5WH6gm9uGmPFVPV9rhYScbfFazFH8oqrj9WGqundJ7PHuc+Cvn6O+KGBLjSrntE1V87j+V6ZiYNmlR6q6eYiFylPMqP/BdvBeDOnQIpImtgdXy57h+MjWlNWzSoCVn3yr+yLn6uyz68b1U9RQpVsx72Iafkfwdj6fCrEo7wfB+sevf5QO+axcy2Md4B8FBttLoz/Zrrf96dxomnabNznGM5mUG+t53ZQBndxByj7BdLxmq4kv5TxVr0tOWNBqyTysD7pYv+ttZJVzss8HaKY6xLTABoIZnedmetsJiafZUHCViunzEP35ZRj/OaZcOlOQIOwPrljjFy1nPRl+VrgMSDDDrYuUZJvq3pBP96NWuDC83lewKnGjokQ7xtH1nuluWIaIyd7DnWW7zb00ufenTLibfNrCPfYFJ8JIPmB5dPeczhGCAuVd4nma8f4sE3ehDj4yNXHs4zN7g1WgkCzxPT86YhOkM6+xmDVR+xlRy/Pfl0pNzM2wMSlLNQQ54p8tpaBHviN9PzKjlaTLQmvlbd9sj4jFKAvfmc26G0FzHQfYTsp5cnXhTefHOQ5l2NzPUXJ1ZmG+XDzI8eH8+Z3EW3dMybcDJMY5y1Jse5oe14vUmR+Q1BC2CjXrlAZ4HuSdYlkFQRnfK6ZoSS9tNDVUcpdpodmi1fEvMaHt5KovgsFiYW3+zYpe3UhT6mUJXSimjOCnWdiMnqaKaWuOVZurlfOEoWjI+w2tItZOIgiNfjhcVjA/HZDZd6EIxnSgiL+4fJWmikTpOcYpT4etwNvChcMhF9qb2cOfaVchoYW79KG4SN9M/0lEKBRRSSB455JBLDjkIsgGFLMCFB3AiaaWVFlppoYVGGjnd1qpQ28RiFstV9tb2c8/a5aQKR095oxjFiJTNw90t14qV7o+mtMNUq3Y9a+a9s11XM1JcwaCkTPE6yVaxidVyrb0dr8rZQaZFvdtbGaQM9AwWfelDeQInOk6l2MNWtipb79zfEe5MB5z3NrMwp4+tt6eXKBWlsoxSyugKdEEhmyKgASdu6oAaqmWVUi2rRRUHxL7TlZnpy1qwYMGCBQsWLFiwYCGV+D+ZSxKMIN18mwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0wOC0xMFQwNTozNDowOSswMDowMIkZh/IAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMDgtMTBUMDU6MzQ6MDkrMDA6MDD4RD9OAAAAAElFTkSuQmCC";
        else
          imgsrc = obj.Profile_Img;
        // imgsrc = "data:" + obj.Profile_ImgType + ";base64," + obj.Profile_Img;
        return imgsrc;
      },

      isImage(obj_File) {
        let ext = String(obj_File.GalFileExt).toUpperCase();
        let isImage = false;

        switch (ext) {
          case ".PNG":
          case ".JPG":
          case ".BMP":
          case ".GIF":
            isImage = true;
            break;
          default:
            isImage = false;
            break;
        }

        return isImage;
      },

      /*#region Array Grouping Function*/
      groupBy(data, key, display, id) {
        //Credits to Ceasar Bautista and Juan Castillo @ stackoverflow
        /*return data.reduce(function(storage, item) {
            let group = item[key];

            storage[group] = storage[group] || [];
            storage[group].push(item);
            return storage;
        }, {});*/
        let ArrObj_Sorted = [];
        let arrstr_display = !this.isNull(display) ? display.split(",") : [key];

        for (let item of data) {
          let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key]);

          if (index === -1) {
            let str_Display = "";
            for (let tempdisp of arrstr_display)
              str_Display += item[tempdisp] + " ";
            // for (let tempdisp of arrstr_display)
            // {
            //     if (display === "CLS_ClassName") {
            //         str_Display += item[tempdisp].trim() + " " + "("+item["CLS_Batch"]+")";
            //     } else {
            //         str_Display += item[tempdisp] + " ";
            //     }
            // }

            ArrObj_Sorted.push({
              Str_SortBy: item[key],
              Str_Display: str_Display,
              Str_ID: item[id],
              ArrObj_Items: [item]
            });
          } else
            ArrObj_Sorted[index].ArrObj_Items.push(item);
        }

        return ArrObj_Sorted;
      }
      /*#endregion*/,

      /*#region Custom check functions*/
      isCheck(id) {
        if (this.isNull(id))
          return;

        let checkbox = $("#" + id);
        // if (checkbox.prop("checked")) {
        //   checkbox.closest("div").addClass("check");
        //   checkbox.closest("div").removeClass("uncheck");
        // } else {
        //   checkbox.closest("div").addClass("uncheck");
        //   checkbox.closest("div").removeClass("check");
        // }
      }
      ,
      /*#endregion*/
      clearChecked() {
        this.isCheckAll = false;
        this.objAlllevels = [];
        this.arr_SelectedLevels.length && this.arr_SelectedLevels.forEach(d => {
          d.checked = false;
          this.onLevelClick(d);
        });
        this.arr_SelectedClasses.length && this.arr_SelectedClasses.forEach(d => {
          d.checked = false;
          this.onClassClick(d);
        });
        this.arrobj_SelectedStudents.length && this.arrobj_SelectedStudents.forEach(d => {
          d.checked = false;
          this.onClassClick(d);
        });
        this.arrobj_SelectedStudents = [];
        this.arr_SelectedClasses = [];
        this.arr_SelectedLevels = [];
        this.checkType = null;

        this.$forceUpdate();
      },
      verifyCheckall(obj) {
        let siblingsCheckbox = $(obj).closest(".collapse").find("input[type='checkbox']");
        let checkallCheckbox = $(obj).closest(".collapse").prev().find("input[type='checkbox']");
        let checkall = true;
        // by jessica 12-1-2021 comment to change format to vue coding
        // siblingsCheckbox.each(function () {
        //   if ($(this).prop("checked") === false) {
        //     checkall = false;
        //     return false;
        //   }
        // });
        for (let item of siblingsCheckbox) {
          if (item.checked === false) {
            checkall = false;
            // if(this.isCheckAll){
            //   this.isCheckAll = false
            // }
            return false;
          }
        }
        // checkallCheckbox.prop("checked", checkall);
        for (let item of checkallCheckbox) {
          if (item.checked === true) {
            checkall = true;
          }
        }
        /* Added by Rajan on 9/11/2021 to pass isalllevel to ActivityStudent*/
        // by jessica 12-1-2021 comment to change format to vue coding
        // checkallCheckbox.each(function () {
        //   if ($(this).prop("checked") === true) {
        //     this.isCheckAll = true;
        //   }
        // });

        if (this.isCheckAll === true) {
          //Added by rajan on 13/11/2021 to fetch alllevels
          for (let tempobj_level of this.arrobj_Levels) {
            this.objAlllevels = tempobj_level.ArrObj_Items;
            for (let tempobj_class of tempobj_level.ArrObj_Items) {
              this.objClasses = tempobj_class.ArrObj_Items;
            }
          }
          this.$emit("isCheckAll", this.isCheckAll);
          this.$emit("tagAllLevels", this.objAlllevels);
          // this.$emit("tagSelectedLevels", this.objAlllevels);
        } else {
          this.$emit("isCheckAll", this.isCheckAll);
          this.$emit("tagAllLevels", this.arrobj_Levels);
        }
      },
      onLevelClick(level) {
        //jessica 12-1-2021 comment by jess
        // if (this.arr_SelectedLevels.length > 1) {
        //   this.$emit("selectedlevels", this.arr_SelectedLevels);
        // }
        this.$emit("handleClear", false);
        this.handle3Level("level", level)
        if (level.checked) {
          const exists = this.arr_SelectedLevels.find(d => d === level);
          if (!exists) {
            this.arr_SelectedLevels.push(level);
          }
        } else {
          this.isCheckAll = false;
          this.arr_SelectedLevels = this.arr_SelectedLevels.filter(d => d !== level);
        }
        this.handleDisabled();
        this.$emit("selectedlevels", this.arr_SelectedLevels);
      },
      onClassClick(classes, level) {
          this.handle3Level("classes", classes, level)
        if (level) {
          classes.levelID = level.Str_ID;
        }
        if (classes.checked) {
          this.checkType = "class";

          const exists = this.arr_SelectedClasses.find(d => d === classes);
          if (!exists) {
            this.arr_SelectedClasses.push(classes);
          }
        } else {
          if (this.checkType === "class") {
            this.checkType = null;
          }
          if (level) {
            level.isLevel = false;
          }
          this.isCheckAll = false;
          this.arr_SelectedClasses = this.arr_SelectedClasses.filter(d => d !== classes);
          this.arr_SelectedLevels = this.arr_SelectedLevels.filter(d => d !== level);
        }
        this.handleDisabled();
        this.$emit("selectedclasses", this.arr_SelectedClasses);
        this.$emit("selectedlevels", this.arr_SelectedLevels);
      },
      checkWholeLevelStatus(level) {
        let allLevelChecked = true;
        level.ArrObj_Items.forEach(d => {
          if (!d.checked) {
            allLevelChecked = false;
          }
        });
        level.checked = allLevelChecked;
        if (level.checked) {
          this.onLevelClick(level);
        }
      },
      resetStudentChecked() {
        this.arrobj_Levels[0].ArrObj_Items.forEach(d => {
          d.ArrObj_Items.forEach(a => {
            a.ArrObj_Items.forEach(x => {
              x.checked = false;
            });
          });
        });
      },
      async onStudentClick(checked, student, classStatus, levelStatus) {
          //flexible select student for broadcast
          if(!this.isBroadcast){
              //only can select same level
              if (this.isSameLevel(levelStatus, "student")) {
                  this.$set(student, "checked", null);
                  return;
              }
              this.handle3Level("student", {checked}, levelStatus);
          }
        this.$emit("handleClear", false);

        if (checked === true) {
          this.checkType = "student";
          if (classStatus && classStatus.checked) {
            student.isClass = true;
          }
          if (student.length > 0 && !this.isMoment) {
            student.forEach(m => {
              let studentID = m.Student_ID || m.PostTagUserID;
              const exists = this.arrobj_SelectedStudents.find(d => d.Student_ID === studentID || d.PostTagUserID === studentID);
              if (!exists) {
                if (this.isMoment) {
                  this.arrobj_SelectedStudents = m;
                } else {
                  this.arrobj_SelectedStudents.push(m);
                }
              }
            });
          } else if (this.isMoment) {
            //able to select one student only for moment post
            await this.resetStudentChecked();
            student.checked = true;
            this.arrobj_SelectedStudents = student;
          } else {
            const exists = this.arrobj_SelectedStudents.find(d => d.Student_ID === student.Student_ID || student.PostTagUserID);
            if (!exists) {
              this.arrobj_SelectedStudents.push(student);
            }
            this.$forceUpdate();
          }

        } else {
          if (this.checkType === "student") {
            this.checkType = null;
          }
          this.isCheckAll = false;
          if (classStatus) {
            classStatus.checked = false;
          }
          if (levelStatus) {
            levelStatus.checked = false;
          }
          this.arrobj_SelectedStudents = this.arrobj_SelectedStudents.filter(d => d.Student_ID !== student.Student_ID);
          this.arr_SelectedClasses = this.arr_SelectedClasses.filter(d => d.Str_Display !== classStatus.Str_Display);
          this.arrobj_SelectedStudents.map(d => d.isClass = false);
          this.$forceUpdate();
        }
        this.handleDisabled();
        this.$emit("selectedclasses", this.arr_SelectedClasses);
        this.$emit("tags", this.arrobj_SelectedStudents);
      },
      // changes
      async bindClasses() {
        try {
          const response = await DataSource.shared.getAttendanceClass();
          if (response) {
            this.class = response.Table;
            this.class.forEach(m => {
              this.arrobj_ClassList.push(m);
            });

            this.arrobj_ClassList.forEach(object => {
              this.arr_ClassName.push(object.CLS_ClassName.trim());
              // this.arr_ClassName.push(object.CLS_ClassName.trim() + " " + "("+object["CLS_Batch"]+")");
              this.arr_ClassInchargeStaff.push(object.CLS_Class_Incharge_Staff);
            });
          }
        } catch (e) {
          this.results = e;
        }
      },

      replaceStringSpace(val) {
        return val.replace(/ /g, "");
      },
      handleCheckAll() {
        this.$emit("handleClear", false);
        this.arrobj_SelectedStudents = [];
        this.$emit("tags", this.arrobj_SelectedStudents);
      },

      //todo: permission start
        checkAllPermission(){
          if(this.isBroadcast){
              return getRole() === "Principal" || getRole() === "Parent Liaison"
          }else{
              return false
          }
        },

        //level permission
        showLevelPermission(){
          return this.userType!=='Teacher'&&!this.isMoment
        },
        checkLevelPermission(tempobj_Level){
            return this.isCheckAll || this.checkType === 'class' || this.checkType === 'student' || this.checkIs3Level(tempobj_Level.Str_Display )
        },

        //class permission
        showClassPermission(){
          return !this.isMoment
        },
        checkClassPermission(tempobj_Level, withSameLevel){
          if(withSameLevel){
              return this.isCheckAll  || this.checkType === 'level' || this.checkType === 'student'||this.checkIs3Level(tempobj_Level.Str_Display )||this.isSameLevel(tempobj_Level,"classes")
          }else{
              return this.isCheckAll  || this.checkType === 'level' || this.checkType === 'student'||this.checkIs3Level(tempobj_Level.Str_Display )
          }
        },

        //student permission
        checkStudentPermission(tempobj_Level){
          return this.isCheckAll   || this.checkType === 'level' || this.checkType === 'class' || this.checkIs3Level(tempobj_Level.Str_Display )
        },


        isSameLevel(data, type){
            if(this.isBroadcast || this.isMoment){
                return false;
            }
            if(type === "classes"){
                return this.arr_SelectedClasses?.[0]?.levelID !==data?.Str_ID
            }else if(type==="student"){
                if (this.arrobj_SelectedStudents?.length > 0 && data?.Str_ID !== this.arrobj_SelectedStudents?.[0]?.PK_Course_ID) {
                    return true;
                }
            }
        },
        handle3Level(type, data, parentData){
          if(!this.isBroadcast){
              if(type === "student"){
                  this.is3Level = parentData?.Str_Display === "Pre-Nursery" || parentData?.Str_Display === "Nursery 1";
              }
              if (data.checked) {
                  if(type === "classes"){
                      if(parentData){
                          this.is3Level = parentData.Str_Display === "Pre-Nursery" || parentData.Str_Display === "Nursery 1";
                      }
                  }else if (type === "student"){
                      this.is3Level = parentData.Str_Display === "Pre-Nursery" || parentData.Str_Display === "Nursery 1";
                  }else{
                      this.is3Level = data.Str_Display === "Pre-Nursery" || data.Str_Display === "Nursery 1";
                  }
              } else {
                  this.check3LevelonUncheck(type);
              }
          }

        },
        checkIs3Level(tempobj_Level) {
            if(this.isBroadcast || this.isMoment){
                return false;
            }
            if (this.is3Level === true) {
                return tempobj_Level !== "Pre-Nursery" && tempobj_Level !== "Nursery 1";
            } else if (this.is3Level === false) {
                return tempobj_Level === "Pre-Nursery" || tempobj_Level === "Nursery 1";
            }
        },
        check3LevelonUncheck(type) {
            this.arr_SelectedLevels.forEach(d => {
                this.is3Level = d.Str_Display === "Nursery 1" || d.Str_Display === "Pre-Nursery";
            });

            switch (type) {
                case "level":
                    if (this.arr_SelectedLevels?.length < 1) {
                        this.is3Level = "";
                    }
                    break;
                case "classes":
                    if (this.arr_SelectedClasses?.length < 1) {
                        this.is3Level = "";
                    }
                    break;
                case "student":
                    if (this.arrobj_SelectedStudents?.length < 1) {
                        this.is3Level = "";
                    }
                    break;
            }

        },
        handleDisabled() {
            if (this.arr_SelectedLevels.length > 0) {
                this.checkType = "level";
            } else if (this.arr_SelectedClasses.length > 0) {
                this.checkType = "class";
            } else if (this.arrobj_SelectedStudents.length > 0) {
                this.checkType = "student";
            } else {
                this.checkType = null;
            }
        },
    },

    updated() {
      const self = this;
      this.$nextTick(function() {
        /*Added by Rajan on 18/11/2021 to get value for check uncheck of alllevels,allclasses and students */
        // Code that will run only after the
        // entire view has been re-rendered
        this.$emit("selectedlevels", this.arr_SelectedLevels);

        // this.$emit("selectedclasses", this.arr_SelectedClasses);
        //Alllevel selected - allclasses is 0
        if (this.isCheckAll) {
          this.$emit("isAllClasses", false);
        }
        //Alllevel not selected,
        if (!this.isCheckAll) {

          if (this.arr_SelectedClasses.length > 1) {
            this.$emit("isAllClasses", true);
          } else {
            this.$emit("isAllClasses", false);
          }


          /*  if(this.arrobj_SelectedStudents.length >=1)
            {
                this.$emit("isselectedstudent",true);
            }
             if(this.arrobj_SelectedStudents.length ===0)
            {
                this.$emit("isselectedstudent",false);
            } */
        }//End Condition - Alllevel not selected


      });//nexttick ends
      //Ends -get value for check uncheck of alllevels,allclasses and students

      $("input[type='checkbox']").each(function() {
        self.isCheck($(this).attr("id"));
        // self.verifyCheckall(this);
      });

      $(".cb_CheckAll").each(function() {
        // self.verifyCheckall(this);
      });
    }
    // props: {
    //   parent_Post: {type: Object, default: null},
    //   portfolio_Type: {type: String, default: null},
    // },
  };
</script>

<style scoped>
    .student {
        width: 75px;
        max-height: 100px;
    }

    /*   label input[type="checkbox"] {
           opacity: 1;
           width: auto;
           height: auto;
           position: inherit;
           top: auto;
           left: auto;
       }
    */
    /*#region On checkbox check transition*/
    label {
        cursor: pointer;
    }

    .check {
        -webkit-transform: scale(0.8);
        -moz-transform: scale(0.8);
        -ms-transform: scale(0.8);
        -o-transform: scale(0.8);
        transform: scale(0.8);
        opacity: 0.5;
        background-color: lightgray;
        transition: all 0.3s;
        /*border: 2px solid black;*/
    }

    .uncheck {
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        -ms-transform: scale(1);
        -o-transform: scale(1);
        transform: scale(1);
        opacity: 1;
        background-color: revert;
        transition: all 0.3s;
    }

    /*#endregion*/

    /*#region Custom Checkbox*/
    .label-checkbox {
        display: block;
        position: relative;
        padding-left: 35px;
        margin-bottom: 12px;
        cursor: pointer;
        font-size: 22px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .span-checkbox {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #eee;
    }

    .label-checkbox:hover ~ .span-checkbox {
        background: #ccc;
    }

    .label-checkbox input:checked ~ .span-checkbox {
        background-color: #2196f3;
    }

    .label-checkbox input:checked ~ .span-checkbox:after {
        display: block;
    }

    .span-checkbox:after {
        content: "";
        position: absolute;
        display: none;
        left: 8px;
        top: 4px;
        width: 8px;
        height: 14px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    /*#endregion*/

    /*#region Custom Tags*/
    .sub-tag .sub-tag__child-empty {
        border-radius: 0px;
        background: whitesmoke;
        border: 0px;
        color: #222;
        text-align: left;
        padding: 10px 20px 10px 40px;
        position: relative;
        cursor: pointer;
    }

    .sub-tag .sub-tag__child-empty.collapsed .span-checkbox {
        border-radius: 20px;
        top: -3px;
        background: #f5f5f5;
    }

    .sub-tag .sub-tag__child-empty.collapsed,
    .sub-tag .sub-tag__child-empty .span-checkbox {
        background: white;
    }

    .sub-tag .sub-tag__child-empty .span-checkbox {
        border-radius: 20px;
        top: -3px;
    }

    .option-tag .sub-tag__child-empty {
        padding-left: 60px;
    }

    .sub-tag .sub-tag__child-empty:hover {
        background: whitesmoke;
    }

    .sub-tag .sub-tag__child-empty:hover .span-checkbox {
        background: white;
    }

    /*#endregion*/
</style>